/* global $ */

import Browser from './Blocks/Browser';

const RENAME_ATTRS = [
  'for',
  'name',
  'id',
  'data-id',
  'data-autocomplete-output',
];

const Blocks = {
  /**
   * Create blocks widget
   * @param {HTMLElement} node
   * @return {void}
   */
  create(node, options) {
    this.node = node;

    this.options = options;

    this.$container = $(this.node).find('.js-blocks-container');

    // Make sure that the numbering of block names is correct
    this.renumber();

    // Get all available block templates
    this.availableBlocks = this.getAvailableBlocks();

    // Create blocks browser
    this.browser = new Browser(this.availableBlocks);

    // Listen for clicks on any action button (up, down, delete etc.)
    $(this.node).on('click', '.js-action-button', (e) => {
      const $el = $(e.currentTarget);
      const $row = this.getBlock($el);

      if ($el.hasClass('is-up')) {
        this.moveBlockUp($row);
      } else if ($el.hasClass('is-down')) {
        this.moveBlockDown($row);
      } else if ($el.hasClass('is-delete')) {
        this.removeBlock($row);
      }
    });

    // Listen for clicks on the button to add a new block
    $(this.node).on('click', '.js-blocks-add', () => {
      this.addBlockBrowser();
    });

    $(this.node).on('change', '.js-toggle-field', () => {
      this.toggleFields();
    });

    this.toggleFields();
  },

  /**
   * Renumber all form elements inside the blocks
   * @return {void}
   */
  renumber() {
    const $blocks = this.getBlocks();

    $blocks.toArray().forEach((block, i) => {
      const $block = $(block);

      RENAME_ATTRS.forEach((attr) => {
        const $els = $block.find(`[${attr}]`);

        if (!$els.length) {
          return;
        }

        $els.toArray().forEach((el) => {
          const $el = $(el);
          const text = $el.attr(attr);

          const newText = text
            .replace(/\w+\[(\d+|##i##)\]/g, `${this.options.blocksName}[${i}]`);

          $el.attr(attr, newText);
        });
      });
    });
  },

  /**
   * Get the parent block element
   * @param {Object} $el
   * @return {Object}
   */
  getBlock($el) {
    return $el.parents('.js-block');
  },

  /**
   * Get all blocks inside the blocks widget
   * @return {Object}
   */
  getBlocks() {
    return $(this.node).find('[data-block]');
  },

  /**
   * Get all available blocks information
   * @return {Array}
   */
  getAvailableBlocks() {
    return $('.js-block-template').toArray().map((item) => {
      const $item = $(item);

      const { id, name, icon } = $item.data();

      return {
        id,
        name,
        icon,
        template: $item.html(),
      };
    });
  },

  /**
   * Get all input elements for element
   * @param {Object} $el
   * @return {Object}
   */
  getInputs($el) {
    return $el.find('input, textarea, select');
  },

  /**
   * Move the block in direction
   * @param {Object} $row
   * @param {String} direction Up or down
   * @return {void}
   */
  moveBlock($row, direction) {
    const $other = $row[direction === 'up' ? 'prev' : 'next']();

    if ($other.length) {
      $other[direction === 'up' ? 'before' : 'after']($row);
      this.renumber();
    }
  },

  /**
   * Move the block element up one element
   * @param {Object} $row
   * @return {void}
   */
  moveBlockUp($row) {
    this.moveBlock($row, 'up');
  },

  /**
   * Move the block element down one element
   * @param {Object} $row
   * @return {void}
   */
  moveBlockDown($row) {
    this.moveBlock($row, 'down');
  },

  /**
   * Remove block element
   * @param {Object} $row
   * @return {void}
   */
  removeBlock($row) {
    $row.remove();
    this.renumber();
  },

  /**
   * Add block element with the given block data
   * @param {Object} block
   * @return {void}
   */
  addBlock(block) {
    this.$container.append(block.template);
    this.renumber();
  },

  /**
   * Show the add block browser
   * @return {void}
   */
  addBlockBrowser() {
    this.browser.open()
      .then(this.addBlock.bind(this))
      .then(() => {
        window.pubsub.publish('components:evaluate');
      });
  },

  /**
   * Show the city name field
   * @return {void}
   */
  toggleFields() {
    const $blocks = this.getBlocks();

    $blocks.toArray().forEach((block) => {
      const $block = $(block);
      const $toggler = $block.find('.js-toggle-field');

      $toggler.each((index, element) => {
        const target = $(element).data('target');
        const $field = $(block).find(`${target}`);

        $field.toggle(element.checked);
      });
    });
  },
};

export default Blocks;
